<div *ngIf="domainNameId.length>1">
  <div class="content-header">Impacted Domains</div>
  <div class="header-helper">
    These are the impacted domains when this request is implemented.
  </div>

  <div class="content content-with-elevation">
    <div class="row domain-list">
  <span class="iana-button domain-button" *ngFor="let domain of domainNameId">
        <a (click)="navigateToViewDomain(domain.id)">{{domain.name| domainNameConverter}}</a>
   </span>
    </div>
  </div>
</div>
